var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_4353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.009 5.396C13.0417 5.396 12.5014 6.36734 12.7215 7.0891L10.3533 9.49048C10.1532 9.42978 9.85964 9.42978 9.65951 9.49048L7.95841 7.7704C8.18522 7.04863 7.64487 6.07054 6.6709 6.07054C5.7036 6.07054 5.15658 7.04189 5.3834 7.7704L2.34142 10.8396C1.62762 10.617 0.666992 11.1634 0.666992 12.1414C0.666992 12.8834 1.26738 13.4905 2.00119 13.4905C2.96849 13.4905 3.50884 12.5192 3.2887 11.7974L6.32401 8.7215C6.52414 8.78221 6.81766 8.78221 7.01779 8.7215L8.7189 10.4416C8.49209 11.1634 9.03244 12.1414 10.0064 12.1414C10.9737 12.1414 11.5207 11.1701 11.2939 10.4416L13.6688 8.04696C14.3826 8.26956 15.3432 7.72318 15.3432 6.74509C15.3432 6.00309 14.7428 5.396 14.009 5.396Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0064 6.07071L10.6335 4.6744L12.0077 4.04707L10.6335 3.41975L10.0064 2.02344L9.3927 3.41975L8.00513 4.04707L9.3927 4.6744L10.0064 6.07071Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33474 7.4196L2.66829 6.07051L4.0025 5.73324L2.66829 5.39597L2.33474 4.04688L2.00119 5.39597L0.666992 5.73324L2.00119 6.07051L2.33474 7.4196Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_4353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0104,
    height: 16.1891,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "97131/static/media/insights.5bf6d4c84de7747626900a88fb07874e.svg";
export { ForwardRef as ReactComponent };